export default {
  welcomeText: "Bienvenue dans la visite virtuelle de",
  title: "La ferme <i>Verticale</i>",
  name: `loading_screen`,
  loadingText: `Chargement`,
  description:
    "L’agriculture verticale consiste à cultiver des produits alimentaires dans des structures verticales afin de produire plus sur moins d’espace, pour répondre à un besoin de proximité dans un contexte de densification des espaces urbains. Il existe plusieurs techniques de culture hors-sol, en milieu fermé permettant de s’affranchir des contraintes météorologiques : l’aéroponie, l’hydroponie, et l’aquaponie.",
  start: "Démarrer",
};
